import { NotificationService } from 'src/app/shared/services/notification.service';

import { inject, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseServices } from 'src/app/kuba/kuba.services';

import { ProductionService } from './../services/production.services';
import { Production } from './../models/production';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';

@Component({
  selector: 'production-list',
  templateUrl: 'production-list.component.html',
  standalone: false
})
export class ProductionListComponent implements OnInit {
  private readonly notifications = inject(NotificationService);
  @ViewChild('dt', { static: false }) dt: Table;
  //#region variable
  productions: any;
  selectedProduction: any;
  parentId: number;
  additionalData: any;
  ProductionControlForm: FormGroup;
  ClientNumberList: any[];
  ClientNameList: any[];
  startDate: Date;
  endDate: Date;
  ProductionTypeList: any[];

  public calendarLocale = {
    firstDayOfWeek: 0,
    dayNames: [
      this.translate.instant('SUNDAY'),
      this.translate.instant('MONDAY'),
      this.translate.instant('TUESDAY'),
      this.translate.instant('WEDNESDAY'),
      this.translate.instant('THURSDAY'),
      this.translate.instant('FRIDAY'),
      this.translate.instant('SATURDAY')
    ],
    dayNamesShort: [
      this.translate.instant('SUN'),
      this.translate.instant('MON'),
      this.translate.instant('TUE'),
      this.translate.instant('WED'),
      this.translate.instant('THU'),
      this.translate.instant('FRI'),
      this.translate.instant('SAT')
    ],
    monthNames: [
      this.translate.instant('JANUARY'),
      this.translate.instant('FEBRUARY'),
      this.translate.instant('MARCH'),
      this.translate.instant('APRIL'),
      this.translate.instant('MAY'),
      this.translate.instant('JUNE'),
      this.translate.instant('JULY'),
      this.translate.instant('AUGUST'),
      this.translate.instant('SEPTEMBER'),
      this.translate.instant('OCTOBER'),
      this.translate.instant('NOVEMBER'),
      this.translate.instant('DECEMBER')
    ],
    today: this.translate.instant('TODAY'),
    clear: this.translate.instant('CLEAR')
  };
  ClientNumber: any;
  ClientName: any;
  ProductionType: any;
  private subscriptions: Subscription[] = [];
  //#endregion

  //#region constructor
  /**
   * Constructor
   * @param route {ActivatedRoute}
   * @param confirmationService {ConfirmationService}
   * @param productionService {ProductionService}
   */
  constructor(
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private productionService: ProductionService,
    private translate: TranslateService,
    private _fb: FormBuilder
  ) {
    this.parentId = route.snapshot.parent.parent.params['id'];
    this.additionalData = {
      fileName: 'Production list',
      header: 'Production list',
      businessId: BaseServices.BusinessId,
      cultureInfo: BaseServices.userCultureInfo(),
      columnNames: [
        { title: 'Client Number', dataKey: 'ClientNumber' },
        { title: 'Client Name', dataKey: 'ClientName' },
        { title: 'Quantity', dataKey: 'Quantity' },
        { title: 'Production Type', dataKey: 'ProductionType' },
        { title: 'Lot Number', dataKey: 'LotNumber' },
        { title: 'Date of delivery', dataKey: 'DeliveryOn' }
      ]
    };
  }
  //#endregion

  //#region page-event
  /**
   * initialization
   */
  ngOnInit() {
    // To hide side menu bar
    document.querySelector('body').classList.remove('opened');
    this.ProductionControlForm = this._fb.group({
      StartDate: [null],
      EndDate: [null]
    });
    this.productions = <Production[]>this.route.snapshot.data['list'];

    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.ClientNumberList = [];
        this.ClientNumberList.push({ label: val.SELECT, value: null });
        if (this.productions) {
          this.productions.forEach(element => {
            if (
              element.ClientNumber != null &&
              element.ClientNumber != '' &&
              this.ClientNumberList.findIndex(
                x => x.label == element.ClientNumber
              ) <= 0
            )
              this.ClientNumberList.push({
                label: element.ClientNumber,
                value: `${element.Id}`
              });
          });
        }
      })
    );
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.ClientNameList = [];
        this.ClientNameList.push({ label: val.SELECT, value: null });
        if (this.productions) {
          this.productions.forEach(element => {
            if (
              element.ClientName != null &&
              element.ClientName != '' &&
              this.ClientNameList.findIndex(
                x => x.label == element.ClientName
              ) <= 0
            )
              this.ClientNameList.push({
                label: element.ClientName,
                value: `${element.Id}`
              });
          });
        }
      })
    );
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.ProductionTypeList = [];
        this.ProductionTypeList.push({ label: val.SELECT, value: null });
        if (this.productions) {
          this.productions.forEach(element => {
            if (
              element.ProductionType != null &&
              element.ProductionType != '' &&
              this.ProductionTypeList.findIndex(
                x => x.label == element.ProductionType
              ) <= 0
            )
              this.ProductionTypeList.push({
                label: element.ProductionType,
                value: `${element.Id}`
              });
          });
        }
      })
    );
  }
  //#endregion

  /**
   * to filter employee in list
   * @param e
   * @param clDropdown
   */
  onSubChanged(e: any, clDropdown: any) {
    if (e.value) {
      // custom filter datatable
      this.dt.filter(clDropdown.selectedOption.label, 'ClientNumber', '');
      this.ClientNumber = e.value;
    } else {
      this.dt.reset();
    }
  }
  /**
   * to filter employee in list
   * @param e
   * @param nameDropdown
   */
  onnameChanged(e: any, nameDropdown: any) {
    if (e.value) {
      // custom filter datatable
      this.dt.filter(nameDropdown.selectedOption.label, 'ClientName', '');
      this.ClientName = e.value;
    } else {
      this.dt.reset();
    }
  }
  /**
   * to filter employee in list
   * @param e
   * @param typeDropdown
   */
  ontypeChanged(e: any, typeDropdown: any) {
    if (e.value) {
      // custom filter datatable
      this.dt.filter(typeDropdown.selectedOption.label, 'ProductionType', '');
      this.ProductionType = e.value;
    } else {
      this.dt.reset();
    }
  }
  /**
   * start date change event
   * @param event {IMyDateModel}
   */
  onStartDateChanged(event: Date | null) {
    this.startDate = event ? new Date(event.getTime()) : null;

    // write into reactive form control (keeps model consistent)
    this.ProductionControlForm.get('StartDate')?.setValue(this.startDate);

    // call filter with start at start-of-day
    this.productionDateRangeFilter(
      this.startDate ? this.startOfDay(this.startDate) : null,
      this.endDate ? this.endOfDay(this.endDate) : null
    );
  }

  onEndDateChanged(event: Date | null) {
    this.endDate = event ? new Date(event.getTime()) : null;
    this.ProductionControlForm.get('EndDate')?.setValue(this.endDate);

    // call filter with end at end-of-day
    this.productionDateRangeFilter(
      this.startDate ? this.startOfDay(this.startDate) : null,
      this.endDate ? this.endOfDay(this.endDate) : null
    );
  }

  private startOfDay(d: Date) {
    const out = new Date(d.getTime());
    out.setHours(0, 0, 0, 0);
    return out;
  }
  private endOfDay(d: Date) {
    const out = new Date(d.getTime());
    out.setHours(23, 59, 59, 999);
    return out;
  }

  /**
   * TimeTable DateRange Filter
   * @param StartDate {any}
   * @param EndDate {any}
   */
  productionDateRangeFilter(StartDate: Date | null, EndDate: Date | null) {
    const start = StartDate
      ? StartDate.getTime()
      : new Date('1800-01-01').getTime();
    const end = EndDate ? EndDate.getTime() : new Date().getTime();

    this.productions = [];
    let list: any[] = this.route.snapshot.data['list'] || [];

    this.productions.push(
      ...list.filter(x => {
        const created = new Date(x.DeliveryOn).getTime();
        return created >= start && created <= end;
      })
    );
  }

  /**
    //#region methods
    /**
     * Bind the Production details
     */
  bindProductionTable() {
    this.subscriptions.push(
      this.productionService
        .getAllProduction(this.parentId)
        .subscribe((result: any) => {
          this.productions = result;
        })
    );
  }
  /**
   * Delete the Production Details
   */
  deleteProduction() {
    let productionIds: any = [];
    if (this.selectedProduction.length > 0) {
      this.selectedProduction.forEach((production: any) => {
        productionIds.push(production.Id);
      });
      this.confirmationService.confirm({
        message: this.translate.instant('DELETE_SELECTED'),
        accept: () => {
          this.subscriptions.push(
            this.productionService
              .deleteProduction(productionIds)
              .subscribe((isProductionDeleted: any) => {
                if (isProductionDeleted) {
                  this.bindProductionTable();
                  this.notifications.success('UI_NOTIFICATIONS.DELETED');
                }
              })
          );
          this.selectedProduction = [];
        },
        reject: () => {
          this.selectedProduction = [];
        }
      });
    } else {
      this.notifications.warn('UI_NOTIFICATIONS.SELECT_PRODUCTION');
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
  //#endregion
}
